import { createContext, useContext } from 'react';

// True only when the subtree is rendered inside a live classroom call
// (the student lesson/quiz view). Defaults to false so the standalone
// lesson, standalone quiz, homework, and Core Skills are unaffected.
export const InClassroomContext = createContext(false);

export const useInClassroom = () => useContext(InClassroomContext);
